export default "__VITE_ASSET__B63dVrcf__"